<template>
    <div>
        <div class="tab">
            <div class="li" :class="type==1?'on':''" @click="type_f(1)">房产租赁</div>
            <div class="li" :class="type==2?'on':''" @click="type_f(2)">房产买卖</div>
        </div>
        <div class="list">
            <div class="wrap">
                <router-link :to="{path:'/details',query:{id:item.id,type:item.module_name}}" class="li" v-for="(item,index) in list" :key="index">
                    <div class="img" :style="'background-image: url('+item.thumb_url+')'"></div>
                    <div class="neir">
                        <div class="p1">{{item.parent_id_name}} <div class="i" :class="item.module_name=='house'?'':'on'">{{item.module_name=='house'?'租赁':'买卖'}}</div></div>
                        <div class="p2">{{item.module_name=='house_all'?item.field3:item.field4_name}}丨{{item.field2}}日元</div>
                        <div class="p3">{{item.address}}/{{item.luxian}}</div>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="page-pagination" ref="pagination">
            <el-pagination align="center" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next" :total="pages.count" :pager-count="5"></el-pagination>
        </div>
        <div class="page_more" ref="page_more">
            <div class="i" v-if="(Math.ceil(pages.count/pages.perpage)) > pages.page" @click="handleCurrentChange(pages.page+1)">查看更多<i class="el-icon-arrow-right"></i></div>
            <div class="i" v-else>没有更多数据</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'latest_property',
    data () {
        return {
            pages: {
                page: 1,
                count: 99,
                perpage: 3,
            },
            list: [],
            type:'', //1房产租赁 2房产买卖
        }
    },
    // 初始事件
    mounted: function () {
        var dom=this.$refs.page_more.offsetParent;
        if(dom===null){
            this.type='';
        }else{
            this.type=1;
        }
        this.init();
    },
    // 事件
    methods: {
        init(){
            var this_ = this;
            var url = "index/house_list";
            var datas = {
                page: this_.pages.page,
                num: this_.pages.perpage,
                type:this_.type,
            };
            this_.$post(url, datas).then((res) => {
                var dom=this_.$refs.page_more.offsetParent;
                var list=res.list;
                if(dom===null||datas.page==1){
                    this_.list = list;
                }else{
                    this_.list=[...this_.list,...list];
                }
                this_.pages.count =res.sum;
            })
        },
        type_f(e){
            this.type=e;
            this.handleCurrentChange(1);
        },
        // 分页每页显示几条
        handleSizeChange(val) {
            this.pages.perpage = val;
            this.init();
        },
        // 切换分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.init();
        }

    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/latest_property.vue